"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Popover = _interopRequireDefault(require("../Popover"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Strings = require("@phg/stilo-utils/Strings");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var HelpIconWrapper = function HelpIconWrapper(_ref) {
  var className = _ref.className,
      children = _ref.children,
      iconClassName = _ref.iconClassName,
      onIconOver = _ref.onIconOver,
      onIconOut = _ref.onIconOut,
      onIconEnter = _ref.onIconEnter,
      onIconLeave = _ref.onIconLeave,
      onIconClick = _ref.onIconClick,
      tooltip = _ref.tooltip,
      tooltipOpen = _ref.tooltipOpen,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'right' : _ref$tooltipPlacement,
      _ref$tooltipOffset = _ref.tooltipOffset,
      tooltipOffset = _ref$tooltipOffset === void 0 ? 0 : _ref$tooltipOffset,
      tooltipClassName = _ref.tooltipClassName,
      tooltipPositionHorizontal = _ref.tooltipPositionHorizontal,
      tooltipPositionVertical = _ref.tooltipPositionVertical,
      tooltipArrowOffset = _ref.tooltipArrowOffset,
      onOutsideClick = _ref.onOutsideClick,
      tooltipSize = _ref.tooltipSize,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "iconClassName", "onIconOver", "onIconOut", "onIconEnter", "onIconLeave", "onIconClick", "tooltip", "tooltipOpen", "tooltipPlacement", "tooltipOffset", "tooltipClassName", "tooltipPositionHorizontal", "tooltipPositionVertical", "tooltipArrowOffset", "onOutsideClick", "tooltipSize"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])(classes.HelpIconWrapper, className)
  }), children, /*#__PURE__*/React.createElement(_Popover["default"], {
    id: (0, _Strings.suffixIfSubject)(rest.id, '-tooltip'),
    anchor: /*#__PURE__*/React.createElement(_Icon["default"], {
      glyph: "help-with-circle",
      id: (0, _Strings.suffixIfSubject)(rest.id, '-icon'),
      className: (0, _classnames["default"])(classes.Icon, iconClassName),
      onMouseOver: onIconOver,
      onMouseOut: onIconOut,
      onMouseEnter: onIconEnter,
      onMouseLeave: onIconLeave,
      onClick: onIconClick,
      style: {
        width: 16,
        height: 16
      },
      "data-test-id": (0, _Strings.suffixIfSubject)(rest.id, '-icon')
    }),
    offset: tooltipOffset,
    placement: tooltipPlacement,
    open: tooltipOpen,
    className: tooltipClassName,
    positionHorizontal: tooltipPositionHorizontal,
    positionVertical: tooltipPositionVertical,
    arrowOffset: tooltipArrowOffset,
    onOutsideClick: onOutsideClick,
    size: tooltipSize,
    "data-test-id": (0, _Strings.suffixIfSubject)(rest.id, '-tooltip')
  }, tooltip));
};

exports["default"] = HelpIconWrapper;
//# sourceMappingURL=index.js.map